var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.currentSubscription
      ? _c(
          "div",
          {
            staticClass: "container",
            attrs: { "data-test-hook": "update-plan-modal" }
          },
          [
            _vm.currentSubscription
              ? _c(
                  "b-row",
                  {
                    staticClass: "mb-0 pb-0 current-plan",
                    attrs: { "align-h": "center", "no-gutters": "" }
                  },
                  [
                    _c("b-col", [
                      _c(
                        "div",
                        {
                          staticClass: "row mb-3 ml-3 mr-3",
                          attrs: { "align-h": "around" }
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "text-center plan-details-header",
                              attrs: {
                                "data-test-hook": "current-plan-support-text"
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("xCurrentPlanSupport", {
                                      0: _vm.currentSubscription.product.name
                                    })
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "b-row",
              { attrs: { "no-gutters": "" } },
              [
                _c(
                  "b-col",
                  { staticStyle: { width: "100%" }, attrs: { cols: "0" } },
                  [
                    _c("SubscriptionUpdateExistingSubCard", {
                      attrs: {
                        subscriptionProduct: _vm.currentSubscription.product,
                        "apparatuses-to-update": _vm.apparatusList
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "b-row",
              {
                staticClass: "mt-3 align-items-center",
                attrs: { "no-gutters": "" }
              },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn mr-3 flex flex-grow-1",
                    staticStyle: { width: "48%" },
                    attrs: {
                      variant: "secondary",
                      "data-test-hook": "cancel-button"
                    },
                    on: {
                      click: function($event) {
                        return _vm.$emit("closeModal")
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("xCancel")) + " ")]
                ),
                _c(
                  "b-button",
                  {
                    staticClass: "btn btn-primary flex flex-grow-1",
                    staticStyle: { width: "48%" },
                    attrs: {
                      variant: "warning",
                      "data-test-hook": "update-to-existing-sub-button"
                    },
                    on: {
                      click: function($event) {
                        return _vm.$emit("updateExistingProductApparatuses")
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("xUpdateNow")) + " ")]
                )
              ],
              1
            ),
            _c(
              "b-row",
              { staticClass: "mt-3" },
              [
                _c("b-col", { staticClass: "text-center" }, [
                  _c("p", { staticClass: "text-small legal-text" }, [
                    _vm._v(
                      "*" +
                        _vm._s(
                          _vm.$t(
                            "xPushNotificationsAreAvailableWithInstallation"
                          )
                        )
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }